import { BankList } from './../../utils/bank-list';
import { Component, Input, OnInit, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Bank } from 'src/app/interfaces/bank';


@Component({
  selector: 'app-select-bank',
  templateUrl: './select-bank.component.html',
  styleUrls: ['./select-bank.component.scss']
})


export class SelectBankComponent implements OnInit, AfterViewInit {

  @Input() code?: string;
  @Input() label?: string;
  @Output() selectionChange = new EventEmitter<Bank | any>()
  protected banks?: Bank[] | any = BankList.list();
  public bankCtrl: FormControl = new FormControl();
  public bankFilterCtrl: FormControl = new FormControl();
  public filteredBanks: ReplaySubject<Bank[]> = new ReplaySubject<Bank[]>(1);

  @ViewChild('singleSelect', { static: true }) singleSelect?: MatSelect | any;

  protected _onDestroy = new Subject<void>();


  constructor() { }

  ngOnInit() {
    if (this.code) {
      const id = this.banks?.filter((bank: Bank) => bank.COMPE === this.code)[0]
      this.bankCtrl.setValue(id);
    }

    this.filteredBanks.next(this.banks?.slice());

    this.bankFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });


  }

  ngAfterViewInit() {
    this.setInitialValue();

    this.bankCtrl.valueChanges.subscribe(bank => {
      this.selectionChange.emit(bank)
    })
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  protected setInitialValue() {
    this.filteredBanks
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: Bank, b: Bank) => a && b && a.COMPE === b.COMPE;
      });
  }

  protected filterBanks() {
    if (!this.banks) return;
    let search = this.bankFilterCtrl.value;

    if (!search) {
      this.filteredBanks.next(this.banks.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBanks.next(
      this.banks.filter((bank: Bank) => bank.LongName.toLowerCase().indexOf(search) > -1 || bank.COMPE.toLowerCase().indexOf(search) > -1 )
    );
  }

  reset(){
    this.bankCtrl.reset();
  }
}
